module.exports = __webpack_public_path__ + "static/img/boss_partsplanning.ae3d68f0.png";